/* eslint-disable no-param-reassign */
import { Editor, Range, Point, Element, Transforms } from 'slate';
import { CustomElement } from '../types';

const withTwoColumns = (editor: any) => {
	const { isVoid, deleteBackward, deleteForward, insertBreak } = editor;

	// editor.isVoid = (element: CustomElement) => {
	// 	if (element.type === 'twoColumns') {
	// 		return true;
	// 	}
	// 	if (element.type === 'column') {
	// 		return false;
	// 	}

	// 	return isVoid(element);
	// };

	editor.deleteBackward = (unit: any) => {
		const { selection } = editor;
		if (selection) {
			const [column] = Editor.nodes(editor, {
				match: (n: any) => !Editor.isEditor(n) && Element.isElement(n) && (n as any).type === 'column',
			});
			const prevNodePath = Editor.before(editor, selection);

			const [twoColumnsNode] = Editor.nodes(editor, {
				at: prevNodePath,
				match: (n: any) => !Editor.isEditor(n) && Element.isElement(n) && (n as any).type === 'column',
			});

			if (column) {
				const [, columnPath] = column;

				const start = Editor.start(editor, columnPath);
				if (Point.equals(selection.anchor, start)) {
					return;
				}
			}
			if (!column && twoColumnsNode) {
				return;
			}
		}

		deleteBackward(unit);
	};
	editor.deleteForward = (unit: any) => {
		const { selection } = editor;
		if (selection && Range.isCollapsed(selection)) {
			const [column] = Editor.nodes(editor, {
				match: (n: any) => !Editor.isEditor(n) && Element.isElement(n) && (n as any).type === 'column',
			});

			const prevNodePath = Editor.after(editor, selection);
			const [twoColumnsNode] = Editor.nodes(editor, {
				at: prevNodePath,
				match: (n: any) => !Editor.isEditor(n) && Element.isElement(n) && (n as any).type === 'column',
			});

			if (column) {
				const [, columnPath] = column;
				const end = Editor.end(editor, columnPath);

				if (Point.equals(selection.anchor, end)) {
					return;
				}
			}
			if (!column && twoColumnsNode) {
				return;
			}
		}

		deleteForward(unit);
	};

	editor.insertBreak = () => {
		const { selection } = editor;
		if (selection) {
			const [twoColumns] = Editor.nodes(editor, {
				match: (n: any) => !Editor.isEditor(n) && Element.isElement(n) && (n as any).type === 'twoColumns',
			});

			if (twoColumns) {
				const [, twoColumnsPath] = twoColumns;
				const end = Editor.end(editor, twoColumnsPath);

				if (Point.equals(selection.anchor, end)) {
					const nextPath = [twoColumnsPath[0] + 1];
					try {
						const nextNode = Editor.node(editor, nextPath);
						if (!nextNode) {
							Transforms.insertNodes(
								editor,
								{
									type: 'paragraph',
									children: [{ text: '' }],
								} as any,
								{ at: nextPath, select: true }
							);
							return;
						}
					} catch (error) {
						// No next node, insert new paragraph
						Transforms.insertNodes(
							editor,
							{
								type: 'paragraph',
								children: [{ text: '' }],
							} as any,
							{ at: nextPath, select: true }
						);
						return;
					}
				}
			}
		}

		insertBreak();
	};

	return editor;
};

export default withTwoColumns;
